export default __webpack_public_path__ + "static/media/plain-sticker-0.7f009993.png";